import { useIncomeTypes } from "@/stores/incomeTypes";
import { incomeSwitchOptions } from "@/utils/incomeTypes";
import React, { useEffect, useRef, useState, useMemo } from "react";
import PageTable from "@/components/i-pageTable/i-pageTable";
import PageTab from "@/components/i-pageTab/i-pageTab";

import {
  getUserTransferWithdrawList,
  addUserTransferWithdraw,
  editUserTransferWithdraw,
  deleteUserTransferWithdraw,
  getUserTransferWithdrawDetail,
} from "@/api/shopping";
import { Alert, message, Modal} from "antd";
import {
  resetForm,
  setIcons,

} from "@/utils/common";

import {
  columns,
  formTab,
  modalFormTab,
} from "./helps";
import { appUserBaseList } from "@/api/index";

export default function CommissionManager() {
  const incomeTypes = useIncomeTypes();
  const withdrawFields = incomeSwitchOptions(incomeTypes, "withdraw").map((item) => item.value);
  const transferFields = incomeSwitchOptions(incomeTypes, "transfer").map((item) => item.value);
  // const dispatch = useDispatch();
  // const {
  //   state: { approval_state, card_type, ns_channel_type },
  // } = useSelector((state: { dictInfo: any }) => state.dictInfo);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [renterOpen, setRenterOpen] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [userList, setUserList] = useState<any[]>([]);

  const [pageData, setPageData] = useState<
    SelectCmsUserCashOrderPageRes["rows"]
  >([]);
  const [formData, setFormData] = useState<any>({
    endTime: "",
    startTime: "",
    ypageNum: 1,
    ypageSize: 10,
    delFlag: 0,
  });
  const [modalFormData, setModalFormData] = useState<any>({});

  const footer = [
    {
      title: "新增",
      icon: setIcons("PlusOutlined"),
      onClick: () => setOpen(true),
      loading: exportLoading,
    },
  ];

  const getUserList = async (val: string) => {
    const res = await appUserBaseList({ mobile: val });
    setUserList(
      res.data.map((item: any) => ({
        label: `${item.nickName}（${item.mobile}）`,
        value: item.userId,
      }))
    );
  };
  // useEffect(() => {
  //   getUserList("");
  // }, []);

  useEffect(() => {
    getPageData();
  }, [formData]);

  const getPageData = async () => {
    setLoading(true);
    try {
      const data = await getUserTransferWithdrawList(formData);
      setPageData(data.rows);
      setTotal(data.total);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const search = (val: any) => {
    setFormData({ ...formData, ...val, ypageNum: 1 });
  };

  const pageChange = (current: number, pageSize: number) => {
    setFormData({
      ...formData,
      ypageNum: current,
      ypageSize: pageSize,
    });
  };

  const confirmData = async (val: any) => {
    const withdrawKeys = val.withdrawKeys || [];
    const transferKeys = val.transferKeys || [];
    const payload = { ...modalFormData, ...val };
    withdrawFields.forEach((key) => {
      payload[key] = withdrawKeys.includes(key) ? 0 : 1;
    });
    transferFields.forEach((key) => {
      payload[key] = transferKeys.includes(key) ? 0 : 1;
    });
    delete payload.withdrawKeys;
    delete payload.transferKeys;

    try {
      if (modalFormData.id) {
        await editUserTransferWithdraw(payload);
      } else {
        await addUserTransferWithdraw(payload);
      }
      message.success("操作成功");
      getPageData();
      closeModal();
    } catch (error) {}
  };

  const reset = () => {
    setFormData({
      ...resetForm(formData),
      delFlag: 0,
    });
  };

  const deleteCommissionData = async (id: string) => {
    try {
      Modal.confirm({
        title: "确定删除该分佣配置吗？",
        onOk: async () => {
          await deleteUserTransferWithdraw(id);
          message.success("已删除");
          getPageData();
        },
      });
    } catch (error) {}
  };

  const closeModal = () => {
    setOpen(false);
    setUserList([]);
    setModalFormData({});
  };

  const editCommissionData = async (val: any) => {
    try {
      const { data } = await getUserTransferWithdrawDetail(val.id);
      const withdrawKeys = withdrawFields.filter(
        (key) => data[key] === 0
      );
      const transferKeys = transferFields.filter(
        (key) => data[key] === 0
      );
      setModalFormData({
        ...data,
        withdrawKeys,
        transferKeys,
      });
      // 用 mobile 搜索，拉取当前用户进下拉选项，Select 才能用 userId 回显昵称(mobile)
      await getUserList(data.mobile || "");
      setOpen(true);
    } catch (error) {
      console.error('获取编辑数据失败:', error);
    }
  };

  const memoizedModalFormTab = modalFormTab(incomeTypes, userList, getUserList);

  return (
    <div>
      <Modal
        destroyOnHidden
        open={open}
        title={modalFormData.id ? "编辑用户提转配置" : "新增用户提转配置"}
        width="580px"
        footer={<></>}
        onCancel={closeModal}
      >
        <Alert type="info" showIcon style={{ marginBottom: 16 }} message="积分开关仅保存配置，实际积分提现和转赠暂未开放。" />
        <PageTab
          subFoot
          search={confirmData}
          reset={closeModal}
          initialValues={modalFormData}
          formTab={memoizedModalFormTab}

        ></PageTab>
      </Modal>
      <PageTab
        defaultTimer={[]}
        reset={reset}
        search={search}
        formTab={formTab}
        footer={footer}
      ></PageTab>
      <PageTable
        loading={loading}
        rowKey="id"
        pageChange={pageChange}
        data={pageData}
        columns={columns({
          incomeTypes,
          setModalFormData,
          setOpen,
          deleteCommissionData,
          editCommissionData,
        })}
        pagination={{
          total: total,
          current: formData.ypageNum,
        }}
      ></PageTable>
    </div>
  );
}
